module.exports = __webpack_public_path__ + "img/partners11.c4929b4d.svg";